import { checkAuthentication } from './middleware';

export const dashboardRoutes = [
    {
        path: '/dashboard',
        name: 'Dashboard',
        component:  () => import(/* webpackChunkName: "dashboard-route" */ '../views/dashboard/Dashboard'),
        beforeEnter: checkAuthentication
    },

]